var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteBase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.49992 17.4167C5.49992 18.425 6.32492 19.25 7.33325 19.25H14.6666C15.6749 19.25 16.4999 18.425 16.4999 17.4167V6.41667H5.49992V17.4167ZM7.33325 8.25H14.6666V17.4167H7.33325V8.25ZM14.2083 3.66667L13.2916 2.75H8.70825L7.79159 3.66667H4.58325V5.5H17.4166V3.66667H14.2083Z",
    fill: "#255986"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBase);
export default __webpack_public_path__ + "static/media/delete_base.b7e341bea02d072912cd753da0f9e796.svg";
export { ForwardRef as ReactComponent };